module['exports'] = ['شہد کی مکھی', 'مکھی', 'چیونٹی'];
